import { render, staticRenderFns } from "./GroupGoodsInfo.vue?vue&type=template&id=fb75bee4&scoped=true"
import script from "./GroupGoodsInfo.vue?vue&type=script&lang=js"
export * from "./GroupGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupGoodsInfo.vue?vue&type=style&index=0&id=fb75bee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb75bee4",
  null
  
)

export default component.exports